<template>
  <div class="info-icons">
    <i class="fas fa-user-secret" title="Falso GPS detectado..." v-if="user.mockGps"></i>

    <i class="fas fa-male" :title="'Usuario sin movimiento ' + precisionText" v-if="user.activityType === ACTIVITY_TYPE.STILL"></i>
    <i class="fas fa-walking" :title="'Usuario desplazándose caminando ' + precisionText" v-if="user.activityType === ACTIVITY_TYPE.WALKING || user.activityType === ACTIVITY_TYPE.ON_FOOT"></i>
    <i class="fas fa-running" :title="'Usuario desplazándose corriendo ' + precisionText" v-if="user.activityType === ACTIVITY_TYPE.RUNNING"></i>
    <i class="fas fa-biking" :title="'Usuario desplazándose en bicicleta ' + precisionText" v-if="user.activityType === ACTIVITY_TYPE.ON_BICYCLE"></i>
    <i class="fas fa-car" :title="'Usuario desplazándose en automóvil ' + precisionText" v-if="user.activityType === ACTIVITY_TYPE.IN_VEHICLE"></i>

    <i class="fas fa-battery-bolt" :title="`Cargando batería... (${user.batteryLevel}%)`" v-if="user.batteryIsCharging"></i>
    <i class="fas fa-battery-half" :title="`${user.batteryLevel}% de carga`" v-if="!user.batteryIsCharging && user.batteryLevel >= 0"></i>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TrackingUserActivityType, TrackingUser } from '@/types/Tracking'

@Component
export default class UserItemInfoIcons extends Vue {
  @Prop({ required: true })
  user: TrackingUser

  ACTIVITY_TYPE = TrackingUserActivityType

  /**
   * Get the corresponding text for precision title
   */
  get precisionText () {
    return ` (${this.user.activityConfidence}% de probabilidad)`
  }
}
</script>

<style scoped>
.info-icons {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 90px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 6px;
}

.info-icons i {
  font-size: 1.2rem;
  opacity: 0;
  margin: 0 4px;
}
</style>
